import ServicioDeActualizacionDeItem from "../../isp.servicios.items/ServicioDeActualizacionDeItem";
import ComandoAPI from "./ComandoAPI";

export default class ComandoActualizarItem extends ComandoAPI {
    constructor() {
        super();
        this.servicio = new ServicioDeActualizacionDeItem();
    }
}
